import { render, staticRenderFns } from "./ProductUpdateModal.vue?vue&type=template&id=2adc966e&scoped=true&"
import script from "./ProductUpdateModal.vue?vue&type=script&lang=js&"
export * from "./ProductUpdateModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductUpdateModal.vue?vue&type=style&index=0&id=2adc966e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adc966e",
  null
  
)

export default component.exports